import {Component, Inject, OnInit} from '@angular/core';



@Component({
  selector: 'app-layout',
  templateUrl: './management.component.html',
  styleUrls: ['./management.component.scss']
})
export class ManagementComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  }



}
